/* tslint:disable */
/* eslint-disable */
/* @relayHash 834bf188d53ad9e176c98d102b478bb8 */

import { ConcreteRequest } from "relay-runtime";
export type presenceHeartbeatSubscriptionVariables = {
    userOrSellerId: string;
};
export type presenceHeartbeatSubscriptionResponse = {
    readonly presence: {
        readonly recentOnlineDate: string | null;
    } | null;
};
export type presenceHeartbeatSubscription = {
    readonly response: presenceHeartbeatSubscriptionResponse;
    readonly variables: presenceHeartbeatSubscriptionVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "userOrSellerId",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "presence",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "userOrSellerId",
        "variableName": "userOrSellerId"
      }
    ],
    "concreteType": "PresenceResults",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "recentOnlineDate",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "presenceHeartbeatSubscription",
    "type": "Subscriptions",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "presenceHeartbeatSubscription",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "subscription",
    "name": "presenceHeartbeatSubscription",
    "id": "app-buyer-finding/295.0.0-2020-12-22T23:44:49.579Z/presenceHeartbeatSubscription",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '69482736691a4636a2d340392ac66f24';
export default node;
